import * as Icons from 'lucide-react';

export function getLucideIcon(name) {
  // Normalize and convert some Material names to Lucide equivalents
  const fallback = 'Circle';
  const cleaned = name?.replace(/_/g, '').replace(/^\w/, (c) => c.toUpperCase()) || fallback;
  return Icons[cleaned] || Icons[fallback];
}